/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditReportsGetAodScheduledRunsScheduledRunsQueryResponse, AuditReportsGetAodScheduledRunsScheduledRuns401, AuditReportsGetAodScheduledRunsScheduledRuns403 } from "../models/AuditReportsGetAodScheduledRunsScheduledRuns";

export function getAuditReportsGetAodScheduledRunsScheduledRunsUrl() {
  const res = { method: 'GET', url: `/audit-reports/v1/aod-runs/scheduled` as const }
  return res
}

/**
 * @description Retrieves all future scheduled runs (enqueued jobs) for all AOD rules belonging to the authenticated user's client
 * @summary Get all scheduled runs for the client
 * {@link /audit-reports/v1/aod-runs/scheduled}
 */
export async function auditReportsGetAodScheduledRunsScheduledRuns(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<AuditReportsGetAodScheduledRunsScheduledRunsQueryResponse, ResponseErrorConfig<AuditReportsGetAodScheduledRunsScheduledRuns401 | AuditReportsGetAodScheduledRunsScheduledRuns403>, unknown>({ method : "GET", url : getAuditReportsGetAodScheduledRunsScheduledRunsUrl().url.toString(), ... requestConfig })
  return res.data
}